// invoice-misc-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'r1i.send.cheerAlt': 'Plumma jubler',
  'r1i.send.postAlt': 'Postplumma med konvolutt',
  'r1i.main.parcelAlt': 'SuperPlumma med pakke',
  'r1i.preview.subscription': 'Abonnement:',
  'r1i.preview.rental': 'Leie:',
});
